'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-e20824bb.js');

const rgTextLargeCss = ":root{--rg-color-theme-muted:#d6d6d6;--rg-color-theme-muted-alt:#f4f4f4;--rg-color-theme-primary:#00497a;--rg-color-theme-primary-alt:#0776aa;--rg-color-theme-secondary:#222222;--rg-color-theme-secondary-alt:#2f2f2f;--rg-color-theme-white:#ffffff;--rg-color-theme-white-alt:#e3e3e3;--rg-base-font-size:12px;--rg-base-font-weight:300;--rg-base-font-color:#222222;--rg-base-font-color-inverse:#ffffff;--rg-heading-font-weight:500;--rg-heading-h4-font-size:16px;--rg-transition-timing:cubic-bezier(0.2, 1, 0.3, 1);--rg-transition-x-slow:1000ms;--rg-transition-slow:500ms;--rg-transition-medium:250ms;--rg-transition-fast:150ms;--rg-transition-x-fast:50ms;--rg-overlay-background-color:rgba(0, 0, 0, 0.6);--rg-focus-outline:1px solid currentColor;--rg-button-theme-primary:var(--rg-color-theme-primary);--rg-button-theme-secondary:var(--rg-color-theme-secondary);--nav-heading-background-color:var(--rg-color-theme-primary);--nav-heading-border-color:var(--rg-color-theme-primary);--nav-link-background-color:var(--rg-color-theme-primary-alt);--nav-link-color:var(--rg-base-font-color-inverse)}:host{display:inline;font-size:20px !important;line-height:1.36 !important}";

const RgTextLarge = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
    }
    // 5. Events section
    // ---------------------------------------
    // 6. Component lifecycle events
    // ---------------------------------------
    // 7. Listeners
    // ---------------------------------------
    // 8. Public methods API
    // ---------------------------------------
    // 9. Local methods
    // ---------------------------------------
    // 10. render() function
    // ---------------------------------------
    render() {
        let style = {
            color: this.textColor,
        };
        return (index.h(index.Host, { style: style }, index.h("slot", null)));
    }
};
RgTextLarge.style = rgTextLargeCss;

exports.rg_text_large = RgTextLarge;
